import { Component } from '@angular/core';

import { L10nService } from '../l10n/l10n.service';

@Component({
    selector: 'gk-layouts',
    templateUrl: './layouts.component.html',
    styleUrls: ['./layouts.component.css'],
    providers: [L10nService],
})
export class LayoutsComponent  {

}
